import React, { Component } from 'react'
import {connect} from 'react-redux'

import {auth} from "../actions";
import { createUser } from '../actions/auth';

class CreateAccount extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            telephone: '',
            loading: false,
            error: "",
        }
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    handleSubmit = (event) => {
        event.preventDefault()
        if (this.state.email.length > 0) {
            this.setState({loading: true})
            this.props.createUser(this.state.email, this.state.telephone)
            .then(res => {
                if (res == 401) {
                    this.setState({
                        loading: false,
                        error: "Finns redan en användare med den emailadressen. Om du redan har ett konto logga in istället",                    
                    })
                } else if (res == 200) {
    
                } else {
    
                }
            })            
        }
    }

    render() {
        return(
                <div>
                    <h1>Skapa abonnemang</h1>           
                    <p className="error">{this.state.error}</p>
                    <form 
                        className="Account-form-nested"
                        onSubmit={this.handleSubmit}
                        >    
                        <div className="form-section">
                            <label className="Account-label">Email</label>
                            <input 
                                value={this.state.email}
                                name="email"
                                placeholder="Email"
                                onChange={this.handleChange}
                                className="Account-input"
                                type="email"
                                />                                 
                        </div>                              
                        <div className="form-section">
                            <label className="Account-label">Telefonummer</label>       
                            <input 
                                value={this.state.telephone}
                                name='telephone'
                                placeholder="Telefonnummer"
                                onChange={this.handleChange}
                                className="Account-input"
                                type="tel"
                                />                                                              
                        </div>                                     
                        {
                            this.state.loading
                            ?
                            <button 
                                className="Account-button" 
                                disabled>
                                Laddar
                            </button>                                 
                            :
                            <button 
                                className="Account-button"
                                type="submit">
                                Skapa konto
                            </button>     
                        }                   
                    </form>                                
                </div>
        )
    }
}


const mapStateToProps = state => {
    return {
    }
}
  
const mapDispatchToProps = dispatch => {
    return {
        createUser: (email,telephone) => {
            return dispatch(auth.createUser(email, telephone));
        }
    }
}
  
  
export default connect(mapStateToProps, mapDispatchToProps)(CreateAccount);


// WEBPACK FOOTER //
// ./src/containers/CreateAccount.jsx